module.exports = __webpack_public_path__ + "media/images/favicon/android-icon-72x72-0c588d28341307c84f2ba008403f6ca9.png";